import { useContext } from 'react';
import { ChartOfAccountsService } from '../services/ChartOfAccountsService';
import { ServiceContext } from '../contexts/ServiceContext';

export const useChartOfAccountsService = (): ChartOfAccountsService => {
  const services = useContext(ServiceContext);
  
  if (!services) {
    throw new Error(
      'useChartOfAccountsService must be used within a ServiceProvider. ' +
      'Please ensure your component is wrapped with ServiceProvider.'
    );
  }

  return services.chartOfAccountsService;
}; 